<script>
import {delLocalItem, filterEmptyParams, getLocalItem, setLocalItem} from "@/untils/common";
import { wx_hdmi_material_delete,wx_hdmi_programPlan_del,wx_hdmi_plan_material_del} from '@/lib/request'
import axios from 'axios';
import {Dialog} from "vant";
export default {
  name:'hdmiMedium',
  data(){
    return {
      // 主体 tab模块
      // 素材、节目单、设置
      activeTab: '0',//0,1,2
      // 素材-类型
      // 官方、自定义
      typeTabIndex: 0,
      tabFind: true,
      typeTab: [
        {
          name: '官方',
          text: '官方素材库',
          number: 0,
          type: 'allIcon',
          icon: 'shop',
          typeList: ["VIDEO", "PICTURE", "URL", "PLUGIN"]
        },
        {
          name: '自定义',
          text: '自定义素材库',
          number: 0,
          type: 'AUTO',
          icon: 'contact',
          typeList: ["AUTO"]
        }
      ],
      // 自定义上传素材
      customizeMaterialsFlag: false,
      showCustomValueParams: {},
      editCustomizeParams: {},
      fileVideoShowUrl: null,
      fileObject: null,
      fileList: [],
      width: null,
      height: null,
      isAndroid: false,
      isUploading: false,
      uploadProgress: 0,
      subDisabled: false,
      listCustomTypeData: [
        {type: 'PICTURE', name: '图片'},
        {type: 'VIDEO', name: '视频'},
      ],
      radioTypeValue: {},
      radioTypeLists: [
        {type: 'PICTURE', name: '横屏'},
        {type: 'VIDEO', name: '竖屏'},
      ],
      // 素材查询条件1-素材名称
      searchInput: '',
      // 素材查询条件2-素材类型
      showMaterialFlag: false,
      showMaterialValueParams: {},//{type: 'PICTURE', name: '图片'},// {type: ['PICTURE', 'VIDEO'], name: '全部类型'},
      SingleNameList: [
        // {type: ['PICTURE', 'VIDEO'], name: '全部类型'},
        {type: 'PICTURE', name: '图片'},
        {type: 'VIDEO', name: '视频'},
        {type: 'URL', name: '网页'},
        {type: 'PLUGIN', name: '插件'},
      ],
      // 素材查询条件3-审核类型
      AdmitNameList: [
        {type: '', name: '全部状态'},
        {type: 'Pass', name: '已通过'},
        {type: 'Pending', name: '待审核'},
        {type: 'Failed', name: '已驳回'},
      ],
      showReviewValueParams: {},// {type:'Pass',name:'已通过'},//{type: '', name: '全部状态'},//默认值//type:'Pass',name:'已通过'
      showReviewFlag: false,
      // 素材列表数据
      page1: 0,
      size1: 20,
      totals1: 0,//总条数
      totalPages1: 0,//总页数
      finished1: true,
      loading1: false,
      finishedMsgTxt: '没有更多了',
      medaListData: [],
      // 公共变量
      icons: {
        'allIcon': '📋',
        'PICTURE': '🖼️',
        'VIDEO': '🎬',
        'URL': '🌐',
        'PLUGIN': '🧩'
      },
      iconsName: {
        'PICTURE': '图片',
        'VIDEO': '视频',
        'URL': '网页',
        'PLUGIN': '插件',
        'AUDIO': '音频',
        'AI': '数字人回答'
      },
      // 屏幕列表
      programTabIndex: 0,
      screenList: [],
      programListObj: [],
      programList: [
        // {
        //   "name": "禁止变造彩票",
        //   "type": "PICTURE",
        //   "networkUrl": null,
        //   "horizontalUrl": "https://test-assistant-backend.oss-cn-beijing.aliyuncs.com/hdmi/resource/d91bd7b242726ce4ed5665b5bb368605.jpg?Expires=1764230977&OSSAccessKeyId=LTAI5tJuHFBezAHJoaYk3bex&Signature=NVXb2%2BiMZIJlvFbHZ%2BlCopygX3E%3D",
        //   "horizontalValue": "1920*1080",
        //   "verticalUrl": "https://test-assistant-backend.oss-cn-beijing.aliyuncs.com/hdmi/resource/e149d44bfecd97cc180359289109511b.jpg?Expires=1764230977&OSSAccessKeyId=LTAI5tJuHFBezAHJoaYk3bex&Signature=ukr08aNs3JVAHCP%2BtRyrOsT%2FHcE%3D",
        //   "verticalValue": "1080*1920",
        //   "usageType": "General",
        //   "review": null,
        //   "id": 20,
        //   "createTime": "2025-10-13 15:51:02",
        //   "updateTime": "2025-10-13 15:51:02"
        // },
      ],
      // 添加节目单或编辑节目单
      programTitle: '',
      liveBackVolume: 20,
      liveState: '',
      liveArrayState: [
        {type: 'ON', name: '是'},
        {type: 'OFF', name: '否'},
      ],
      showMaterialOfficialFlag: false,
      editObj: {},
      // 屏幕内的素材编辑
      showCustomTypeFlag: false,
      // 屏幕内-添加素材
      showAddFlag: false,
      //屏幕内素材编辑资料
      objScreenItem: {},
      playbackVolume: 20,
      screenDuration: '',
      materialObj: {},
      programItem: {},
      // -----
      siteId: '',
      // -----
    }
  },
  watch: {
    // 监控参数变化
    searchParams: {
      handler(newVal, oldVal) {
        // 添加变化检测逻辑
        const isNameChanged = newVal.materialName !== oldVal.materialName;
        const isTypesChanged = JSON.stringify(newVal.materialType) !== JSON.stringify(oldVal.materialType);
        if (isNameChanged || isTypesChanged) {
          this.page1 = 0;
        }
        this.getListData();
      },
      deep: true,
      // immediate: false // 设为 false 避免初始化执行
    },
  },
  computed: {
    type1Count() {
      return this.programListObj.length > 1 ? this.programListObj[1].programs.filter(item => item.typical && item.typical === 'System').length : this.programListObj[0].programs.filter(item => item.typical && item.typical === 'System').length;
    },
    // 监控参数变化
    searchParams() {
      return {
        netWorkNumber: this.typeTabIndex === 1 ? this.siteId : '',//网点编号
        materialName: this.searchInput,//按名称搜索
        page: this.page1,//页数
        size: this.size1,//条数
        materialType: this.showMaterialValueParams.type,
        usageType: this.typeTabIndex !== 1 ? 'General' : 'Personal',//素材使用类型['Personal-个人','General-通用']
        reviewStatus: this.typeTabIndex !== 1 ? '' : this.showReviewValueParams.type,//素材审核状态[待审核Pending,审核通过Pass,审核未通过Failed]
      };
    },
  },
  methods: {
    // 主体 tab模块 切换
    // 触发
    onHeadTab(index) {
      if (index === '0') {
        this.showMaterialValueParams = this.SingleNameList[0];
        this.showReviewValueParams = this.AdmitNameList[0];
      } else if (index === '1') {
        this.programTabIndex = 0;
        // 所有盒子
        this.getBoxAll();
      } else if (index === '2') {

      }
    },
    // 素材-类型 切换（官方、自定义）
    onTabCurrent(index) {
      if (this.tabFind) {
        this.page1 = 0;
        this.typeTabIndex = index;
        // 如果是自定义素材，清空输入框的内容
        if (index === 1) {
          this.showMaterialValueParams = {type: '', name: '全部类型'};
          this.SingleNameList = [
            {type: '', name: '全部类型'},
            {type: 'PICTURE', name: '图片'},
            {type: 'VIDEO', name: '视频'},
          ]
          this.searchInput = '';
        } else {
          this.showMaterialValueParams = {type: 'PICTURE', name: '图片'};
          this.SingleNameList = [
            // {type: '', name: '全部类型'},
            {type: 'PICTURE', name: '图片'},
            {type: 'VIDEO', name: '视频'},
            {type: 'URL', name: '网页'},
            {type: 'PLUGIN', name: '插件'},
          ]
        }
      } else {
        this.$toast('操作过急！');
      }
    },
    // 上传自定义素材
    getShowMeta() {
      this.customizeMaterialsFlag = true;
      this.editCustomizeParams = {};
      this.showCustomValueParams = {};
      this.radioTypeValue = {};
      this.fileList = [];
      this.fileVideoShowUrl = null;
      this.fileObject = null;
    },
    // 添加上传提交素材资料表单（和修改资料）
    onAddFigure() {
      if (!this.showCustomValueParams.name) {
        this.$toast('请选择素材类型！');
        return false;
      }
      if (!this.editCustomizeParams.name) {
        this.$toast('请填写素材标题！');
        return false;
      }
      // if (!this.editCustomizeParams.description) {
      //   this.$toast('请填写素材描述！');
      //   return false;
      // }
      if (!this.radioTypeValue.name) {
        this.$toast('请选择屏幕方向！');
        return false;
      }
      if (!this.editCustomizeParams.id) {
        // 新增
        if (!this.fileObject) {
          this.$toast('请上传素材！');
          return false;
        }
        if (!this.fileObject.name) {
          this.$toast('请上传素材！');
          return false;
        }
      } else {
        // 修改
        if (!this.fileObject) {
          this.$toast('请重新上传素材！');
          return false;
        }
        if (!this.fileObject.name) {
          this.$toast('请重新上传素材！');
          return false;
        }
      }
      if (!this.fileObject.name) {
        this.$toast('请上传素材！');
        return false;
      }
      // 兼容安卓和ios微信浏览器
      this.uploadVideo();
    },
    // 表单取消按钮
    getCancel() {
      if (this.subDisabled) {
        this.$toast('资料上传中！');
        return false;
      }
      this.customizeMaterialsFlag = false;
      this.subDisabled = false;
    },
    // 选择素材类型
    onMaterialType(value) {
      this.showMaterialValueParams = value;
      this.showMaterialFlag = false;
    },
    // 选择审核类型
    onReviewType(value) {
      this.showReviewValueParams = value;
      this.showReviewFlag = false;
    },
    // 素材列表数据
    onLoad() {
      setTimeout(() => {
        if (this.page1 < this.totalPages1) {
          this.page1 = this.page1 + 1;
        }
      }, 1000);
    },
    getListData() {
      let that = this;
      that.tabFind = false;
      that.loading1 = true;
      that.finished1 = false;
      if (that.searchParams.page1 === 0) {
        that.medaListData = [];
      }
      that.$http.wx_hdmi_material_list(filterEmptyParams(that.searchParams)).then((res) => {
        if (res) {
          if (res.code === 200) {
            that.loading1 = false;
            if (res.data) {
              that.tabFind = true;
              let resData = res.data.rows;
              that.totals1 = res.data.totalRows;
              that.totalPages1 = Math.ceil(res.data.totalRows / that.size1) - 1;
              if (resData === null || resData.length === 0) {
                that.finished1 = true;
                that.medaListData = [];
                return false;
              } else {
                resData.map((v) => {
                  v.enable = null;
                  v.checked = null;
                });
                if (this.programListObj.length > 0) {
                  resData.map((v) => {
                    this.programListObj.map((value) => {
                      value.programs.map((k) => {
                        if (k.materialId === v.id) {
                          v.enable = true;
                          v.checked = true;
                        }
                      });
                    });
                  });
                }
                if (that.page1 > 0) {
                  that.medaListData = that.medaListData.concat(resData);
                } else {
                  that.medaListData = resData;
                }
                // 总条数和每页条数
                if (that.totals1 < that.size1) {
                  that.finished1 = true;
                  return;
                }
                // 当前页和总页数
                if (that.page1 === that.totalPages1) {
                  that.finished1 = true;
                  return false;
                }
              }
            } else {
              that.tabFind = true;
              that.$toast.fail('data无数据！');
            }
          } else {
            that.tabFind = true;
            that.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    // getTypeNumber() {
    //   this.$http.medium_marketingMaterialsCountByType({
    //     networkId: this.siteId,
    //     size: 20,
    //     name: this.searchInput,//按名称搜索
    //     usageType: 'General',
    //     types: ["VIDEO", "PICTURE", "URL", "PLUGIN"],//素材类型，可传多个类型
    //   }).then((res) => {
    //     if (res) {
    //       if (res.code === 200) {
    //         if (res.data) {
    //           let num = 0;
    //           res.data.map((v) => {
    //             num += v.total;
    //             this.typeTab.map((i) => {
    //               if (v.type === i.type) {
    //                 i.number = v.total;
    //               }
    //             });
    //           });
    //           this.typeTab.map((i) => {
    //             if (i.type === 'allIcon') {
    //               i.number = num
    //             }
    //           });
    //           this.getTypeNumberAuto();
    //         }
    //       } else {
    //         this.$toast.fail(res.message);
    //         return false;
    //       }
    //     }
    //   });
    // },
    // getTypeNumberAuto() {
    //   this.$http.medium_marketingMaterialsCountByType({
    //     networkId: this.siteId,
    //     size: 20,
    //     name: this.searchInput,//按名称搜索
    //     usageType: 'Personal',
    //     types: ["VIDEO", "PICTURE"],//素材类型，可传多个类型
    //   }).then((res) => {
    //     if (res) {
    //       if (res.code === 200) {
    //         if (res.data) {
    //           let num = 0;
    //           res.data.map((v) => {
    //             num += v.total;
    //           });
    //           this.typeTab.map((i) => {
    //             if (i.type === 'AUTO') {
    //               i.number = num;
    //             }
    //           });
    //         }
    //       } else {
    //         this.$toast.fail(res.message);
    //         return false;
    //       }
    //     }
    //   });
    // },
    // 自定义-编辑素材
    onEditFigureItem(item) {
      if (item.horizontalUrl) {
        this.radioTypeValue = {name: '横屏', type: 'PORTRAIT'}
        this.fileList = [{url: item.horizontalUrl}];
      } else if (item.verticalUrl) {
        this.radioTypeValue = {name: '竖屏', type: 'LANDSCAPE'}
        this.fileList = [{url: item.verticalUrl}];
      }
      this.fileVideoShowUrl = null;
      this.fileObject = null;
      this.customizeMaterialsFlag = true;
      this.editCustomizeParams = item;
      this.listCustomTypeData.map((v) => {
        if (v.type === item.type) {
          this.showCustomValueParams = v;
        }
      });
    },
    // 自定义-删除素材
    onDeleteFigure(item) {
      Dialog.confirm({
        title: '',
        message: `确定删除"${item.name}"吗？`,
      }).then(() => {
        // on confirm
        wx_hdmi_material_delete({id: item.id}).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                this.$toast.success('删除成功！');
                this.getListData();
              } else {
                this.$toast.fail(res.message);
                return false;
              }
            }
          }
        });
      }).catch(() => {
        // on cancel
        console.log('cancel')
      });
    },
    // 添加屏幕+1
    getAddScreenMeta() {
      this.programTitle = '';
      this.liveState = '';
      this.liveBackVolume = 20;
      this.showMaterialOfficialFlag = true;
    },
    // 屏幕数据tab切换
    onProgramTabCurrent(index) {
      this.programTabIndex = index;
      this.getItemList(this.screenList[index].value)
    },
    // 某条屏幕编辑
    getEditGroupScreen(item) {
      this.programItem = item;
      this.programTitle = item.programPlanName;
      this.liveState = item.liveStatus;
      this.liveBackVolume = item.liveVolume;
      this.showMaterialOfficialFlag = true;
    },
    // 屏幕编辑名称
    getScreenNameAdd() {
      if (!this.programTitle) {
        this.$toast('请填写节目单名称');
        return false;
      }
      if (this.liveState === '') {
        this.$toast('请选择是否开启直播');
        return false;
      }
      if (this.liveBackVolume < 1) {
        this.$toast('请设置直播音量');
        return false;
      }
      let params = {
        "name": this.programTitle,
        "liveStatus": this.liveState,
        "liveVolume": this.liveBackVolume
      }
      if (!this.programItem.programPlanId) {
        params.id = this.screenList[this.programTabIndex].value.toString();
        // 新增节目单
        this.$http.wx_hdmi_programPlan_add(params).then((res) => {
          if (res) {
            if (res.code === 200) {
              this.$toast.success('添加成功！');
              this.showMaterialOfficialFlag = false;
              this.getItemList(this.screenList[this.programTabIndex].value);
            } else {
              this.$toast.fail(res.message);
              return false;
            }
          }
        });
      } else {
        // 修改节目单
        params.id = this.programItem.programPlanId;
        this.$http.wx_hdmi_programPlan_update(params).then((res) => {
          if (res) {
            if (res.code === 200) {
              this.$toast.success('修改成功！');
              this.showMaterialOfficialFlag = false;
              this.getItemList(this.screenList[this.programTabIndex].value);
            } else {
              this.$toast.fail(res.message);
              return false;
            }
          }
        });
      }

    },
    // 屏幕编辑取消
    getScreenNameCancel() {
      this.editObj = {};
      this.showMaterialOfficialFlag = false;
    },
    // 某条屏幕保存
    getScreenSave(item) {
      if (!item.type) {
        this.$toast('请选择屏幕方向');
        return false;
      }
    },
    // 节目单删除
    getDelGroupScreen(item) {
      Dialog.confirm({
        title: '',
        message: `确定删除"${item.programPlanName}"吗？`,
      }).then(() => {
        // on confirm
        wx_hdmi_programPlan_del({id: item.programPlanId}).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                this.$toast.success('删除成功！');
                this.getItemList(this.screenList[this.programTabIndex].value)
              } else {
                this.$toast.fail(res.data.message);
                return false;
              }
            }
          }
        });
      }).catch(() => {
        // on cancel
        console.log('cancel')
      });
    },
    // 屏幕内的素材编辑提交
    onAddScreen() {
      if (!this.objScreenItem.name) {
        this.$toast('请填写素材标题！')
        return false;
      }
      if (!this.objScreenItem.duration) {
        this.$toast('请填写播放时长！')
        return false;
      }
      if (this.objScreenItem.type !== 'PICTURE') {
        if (this.playbackVolume < 1) {
          this.$toast('请设置播放音量！');
          return false;
        }
      }
      let params = {
        programId: this.objScreenItem.id,
        materialId: this.objScreenItem.materialId,
        type: this.objScreenItem.type,
        duration: this.objScreenItem.duration,
        volume: this.playbackVolume
      };
      this.$http.wx_hdmi_plan_material_update(params).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.$toast.success('修改成功！');
            this.showCustomTypeFlag = false;
            this.getItemList(this.screenList[this.programTabIndex].value);
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    // 屏幕内的素材取消
    getScreenCancel() {
      this.objScreenItem = {};
      this.showCustomTypeFlag = false;
    },
    // 屏幕内的素材编辑
    onEditScreenItem(item) {
      this.objScreenItem = item;
      this.playbackVolume = item.volume;
      this.showCustomTypeFlag = true;
    },
    // 节目单内的素材删除
    onDeleteScreenItem(item) {
      Dialog.confirm({
        title: '',
        message: `确定删除"${item.name}"吗？`,
      }).then(() => {
        // on confirm
        wx_hdmi_plan_material_del({id: item.id}).then((res) => {
          if (res) {
            if (res.data) {
              if (res.data.code === 200) {
                this.$toast.success('删除成功！');
                this.getItemList(this.screenList[this.programTabIndex].value);
                // 素材类型的数量
                // this.getTypeNumber();
              } else {
                this.$toast.fail(res.message);
                return false;
              }
            }
          }
        });
      }).catch(() => {
        // on cancel
        console.log('cancel')
      });
    },
    addMate(item) {
      this.SingleNameList = [
        // {type: ['PICTURE', 'VIDEO'], name: '全部类型'},
        {type: 'PICTURE', name: '图片'},
        {type: 'VIDEO', name: '视频'},
        {type: 'URL', name: '网页'},
        {type: 'PLUGIN', name: '插件'},
      ];
      this.showMaterialValueParams = this.SingleNameList[0];
      this.showReviewValueParams = this.AdmitNameList[0];
      this.typeTabIndex = 0;
      this.searchInput = '';
      this.showAddFlag = true;
      this.materialObj = {};
      this.screenDuration = '';
      // this.playbackVolume = 0;
      this.programItem = item;
      this.page1 = 0;
      // this.showReviewValueParams = {type:'Pass',name:'已通过'};
      this.getListData();
    },
    // 向上移动一位
    getOnMoveUp(item, v, index) {
      this.$http.wx_hdmi_plan_material_move({
        "preProgramId": v.id,
        "nextProgramId": item.programs[index - 1].id
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.getItemList(this.screenList[this.programTabIndex].value);
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    // 向下移动一位
    getOnMoveDown(item, v, index) {
      this.$http.wx_hdmi_plan_material_move({
        "preProgramId": v.id,
        "nextProgramId": item.programs[index + 1].id
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.getItemList(this.screenList[this.programTabIndex].value);
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    //是否直播
    getOnUpSwitch(item) {
      let titleString = ''
      if (item.liveStatus === 'ON') {
        item.liveStatus = 'OFF';
        titleString = '关闭'
      } else {
        item.liveStatus = 'ON';
        titleString = '开启'
      }
      // 修改节目单
      let params = {
        "id": item.programPlanId.toString(),
        "name": item.programPlanName,
        "liveStatus": item.liveStatus,
        "liveVolume": item.liveVolume
      }
      this.$http.wx_hdmi_programPlan_update(params).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.$toast.success(`${titleString}直播设置成功！`);
            this.getItemList(this.screenList[this.programTabIndex].value);
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    //推送功能
    getBoxProgramPush(item) {
      this.$http.wx_hdmi_programPlan_push({
        id: item.programPlanId
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.$toast.success('推送设置成功！');
            this.getItemList(this.screenList[this.programTabIndex].value);
          } else {
            this.$toast(res.message);
            return false;
          }
        }
      });
    },
    getOnSwitch(item) {
      item.checked = !item.checked;
      if (item.checked) {
        this.medaListData.map((v) => {
          if (!v.enable) {
            v.checked = v.id === item.id;
          }
        });
        this.materialObj = item;
      }
    },
    // 查询所有盒子
    getBoxAll() {
      this.$http.wx_hdmi_listAll({
        netWorkNumber: this.siteId
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.screenList = res.data;

            if (res.data && res.data.length > 0) {
              this.getItemList(res.data[0].value);
            }
          } else {
            this.screenList = [];
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    getItemList(id) {
      this.$http.wx_hdmi_programPlan({id: id}).then((res) => {
        if (res) {
          if (res.code === 200) {
            if (res.data) {
              let arr = [];
              if (res.data.General) {
                res.data.General.logCheck = res.data.General.liveStatus === 'ON';
                res.data.General.typical = 'System';
                arr.push(res.data.General);
              }
              if (res.data.Personal) {
                res.data.Personal.logCheck = res.data.Personal.liveStatus === 'ON';
                res.data.Personal.typical = '1';
                arr.push(res.data.Personal);
              }
              this.programListObj = arr;
            } else {
              this.programListObj = [];
            }
          } else {
            this.programListObj = [];
            this.$toast.fail(res.message);
            return false;
          }
        }
      })
    },
    beforeRead(e) {
      if (!this.showCustomValueParams.name) {
        this.$toast('请您选择素材类型！');
        return false;
      }
      if (this.showCustomValueParams.name === '图片') {
        // 检查图片大小
        const isLt5M = e.size / 1024 / 1024 < 5;
        console.log(e.size, isLt5M, e.size / 1024 / 1024 + 'MB')
        if (!isLt5M) {
          this.$toast('图片大小不能超过5MB!');
          return false;
        }
        if (e.type.split('/')[0] !== 'image') {
          this.$toast('请您选择图片类型！');
          return false;
        }
      } else if (this.showCustomValueParams.name === '视频') {
        // 检查视频大小
        const isLt5M = e.size / 1024 / 1024 < 500;
        console.log(e.size, isLt5M, e.size / 1024 / 1024 + 'MB')
        if (!isLt5M) {
          this.$toast('视频大小不能超过500MB!');
          return false;
        }
        if (e.type.split('/')[0] !== 'video') {
          this.$toast('请您选择视频类型！');
          return false;
        }
      }
      return true;
    },
    getReadDelete() {
      if (this.fileVideoShowUrl) {
        this.fileVideoShowUrl = null;
      }
      this.fileObject = {};
      this.fileList = [];
      this.subDisabled = false;
    },
    // 文件选择变化
    onFileChange(e) {
      this.afterRead(e);
    },
    afterRead(e) {
      if (!this.showCustomValueParams.name) {
        this.$toast('请您选择素材类型！');
        return false;
      }
      if (this.showCustomValueParams.name === '图片') {
        if (e.file.type.split('/')[0] !== 'image') {
          this.$toast('请您选择图片类型！');
          return false;
        }
      } else if (this.showCustomValueParams.name === '视频') {
        if (this.isAndroid) {
          // 安卓机器访问进入
          const files = e.target.files[0];
          // if (files.type.indexOf('mp4') !== -1) {
          // } else {
          //   this.$toast('请您选择MP4的视频格式！');
          //   return false;
          // }
          if (files.type.split('/')[0] !== 'video') {
            this.$toast('请您选择视频类型！');
            return false;
          }
        } else {
          // if (e.file.type.indexOf('mp4') !== -1) {
          // } else {
          //   this.$toast('请您选择MP4的视频格式！');
          //   return false;
          // }
          if (e.file.type.split('/')[0] !== 'video') {
            this.$toast('请您选择视频类型！');
            return false;
          }
        }
      }
      if (this.fileList.length > 1) {
        this.fileList = [this.fileList[this.fileList.length - 1]];
      }
      if (this.showCustomValueParams.name === '视频') {
        let that = this;
        // 视频
        if (this.isAndroid) {
          const file = e.target.files[0];
          this.fileObject = file;
          that.fileVideoShowUrl = URL.createObjectURL(file);
          that.fileList = [file]
        } else {
          this.fileObject = e.file;
          const file = e.file;
          that.fileVideoShowUrl = URL.createObjectURL(file);
        }
        // // 创建video元素
        // const video = document.createElement('video');
        // video.src = that.fileVideoShowUrl;
        // video.addEventListener('loadedmetadata', () => {
        //   console.log(video.videoWidth,video.videoHeight)
        //   // 获取视频的宽高
        //   that.width = video.videoWidth;
        //   that.height = video.videoHeight;
        // });
      } else if (this.showCustomValueParams.name === '图片') {
        this.fileObject = e.file;
        // const file = e.file;
        // // 图片
        // const reader = new FileReader();
        // reader.onload = (e) => {
        //   const img = new Image();
        //   img.onload = () => {
        //     this.width = img.width;
        //     this.height = img.height;
        //   };
        //   img.src = e.target.result; // 设置img的src为读取的文件内容URL
        // };
        // reader.readAsDataURL(file);
      }
      this.innerLoading = false;
    },
    // 上传视频文件
    async uploadVideo() {
      if (!this.fileObject.name) {
        this.$toast('请上传素材！');
        return false;
      }
      this.subDisabled = true;
      this.isUploading = true;
      this.uploadProgress = 0;
      try {
        // 创建FormData对象
        const formData = new FormData();
        formData.append('netWorkNumber', this.siteId);
        formData.append('type', this.showCustomValueParams.name === '视频' ? 'VIDEO' : 'PICTURE');
        formData.append('name', this.editCustomizeParams.name);
        formData.append('screenType', this.radioTypeValue.name === '竖屏' ? 'PORTRAIT' : 'LANDSCAPE');
        formData.append('file', this.fileObject); // 文件对象

        // 安卓设备特殊处理
        if (this.isAndroid) {
          // 新增
          if (!this.editCustomizeParams.id) {
            await this.uploadForAndroid(formData);
          } else {
            // 修改
            formData.append('id', this.editCustomizeParams.id);
            await this.uploadForAndroidUpdate(formData);
          }
        } else {
          // 新增
          if (!this.editCustomizeParams.id) {
            await this.uploadStandard(formData);
          } else {
            // 修改
            formData.append('id', this.editCustomizeParams.id);
            await this.uploadStandardUpdate(formData);
          }
        }
        this.isUploading = false;
        this.subDisabled = false;
      } catch (error) {
        this.isUploading = false;
        this.subDisabled = false;
        this.handleUploadError(error);
      }
    },
    // 处理上传错误
    handleUploadError(error) {
      if (error.code === 'ECONNABORTED' || error.message.includes('timeout')) {
        this.$toast.fail('上传超时，请检查网络连接后重试');
        return false;
      } else if (error.message.includes('Network Error')) {
        this.$toast.fail('网络错误，请检查网络连接');
        return false;
      } else if (error.response) {
        this.$toast.fail(`服务器错误: ${error.response.status}`);
        return false;
      } else {
        this.$toast.fail(`上传失败: ${error.message}`);
        return false;
      }
    },
    // 新增上传资料，ios
    // 标准上传方法
    uploadStandard(formData) {
      return new Promise((resolve, reject) => {
        axios.post('api/xzxzs/api/wx/hdmi/material/add', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          timeout: 120000, // 2分钟超时
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.uploadProgress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
              );
            }
          }
        }).then(response => {
          // 成功响应
          if (response.data) {
            if (response.data.code === 200) {
              this.subDisabled = false;
              this.customizeMaterialsFlag = false;
              this.$toast.success('提交成功！');
              // 查询素材列表数据
              this.getListData();
            } else {
              this.subDisabled = false;
              this.$toast.fail(response.data.message);
              return false;
            }
          }
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 修改上传资料 ios
    uploadStandardUpdate(formData) {
      return new Promise((resolve, reject) => {
        axios.post('api/xzxzs/api/wx/hdmi/material/add', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          timeout: 120000, // 2分钟超时
          onUploadProgress: (progressEvent) => {
            if (progressEvent.lengthComputable) {
              this.uploadProgress = Math.round(
                  (progressEvent.loaded * 100) / progressEvent.total
              );
            }
          }
        }).then(response => {
          // 成功响应
          if (response.data) {
            if (response.data.code === 200) {
              this.subDisabled = false;
              this.customizeMaterialsFlag = false;
              this.$toast.success('提交成功！');
              // 查询素材列表数据
              this.getListData();
            } else {
              this.$toast.fail(response.data.message);
              return false;
            }
          }
          resolve(response);
        }).catch(error => {
          reject(error);
        });
      });
    },
    // 新增上传资料
    // 安卓设备专用上传方法
    uploadForAndroid(formData) {
      return new Promise((resolve, reject) => {
        // 使用更简单的配置，避免安卓兼容性问题
        const xhr = new XMLHttpRequest();

        xhr.upload.addEventListener('progress', (e) => {
          if (e.lengthComputable) {
            this.uploadProgress = Math.round((e.loaded * 100) / e.total);
          }
        });

        xhr.addEventListener('load', () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            // 成功响应
            let response = JSON.parse(xhr.response)
            if (response) {
              if (response.code === 200) {
                this.subDisabled = false;
                this.customizeMaterialsFlag = false;
                this.$toast.success('提交成功！');
                // 查询素材列表数据
                this.getListData();
              } else {
                this.$toast.fail(response.message);
                return false;
              }
            }
            resolve({data: 'success'});
          } else {
            reject(new Error(`上传失败: ${xhr.status}`));
          }
        });

        xhr.addEventListener('error', () => {
          reject(new Error('网络错误，请检查网络连接'));
        });

        xhr.addEventListener('timeout', () => {
          reject(new Error('上传超时，请重试'));
        });

        xhr.timeout = 120000; // 2分钟超时
        xhr.open('POST', 'api/xzxzs/api/wx/hdmi/material/add');
        xhr.send(formData);
      });
    },
    // 修改上传资料
    uploadForAndroidUpdate(formData) {
      return new Promise((resolve, reject) => {
        // 使用更简单的配置，避免安卓兼容性问题
        const xhr = new XMLHttpRequest();

        xhr.upload.addEventListener('progress', (e) => {
          if (e.lengthComputable) {
            this.uploadProgress = Math.round((e.loaded * 100) / e.total);
          }
        });

        xhr.addEventListener('load', () => {
          if (xhr.status >= 200 && xhr.status < 300) {
            // 成功响应
            let response = JSON.parse(xhr.response)
            if (response) {
              if (response.code === 200) {
                this.subDisabled = false;
                this.customizeMaterialsFlag = false;
                this.$toast.success('提交成功！');
                // 查询素材列表数据
                this.getListData();
              } else {
                this.$toast.fail(response.message);
                return false;
              }
            }
            resolve({data: 'success'});
          } else {
            reject(new Error(`上传失败: ${xhr.status}`));
          }
        });

        xhr.addEventListener('error', () => {
          reject(new Error('网络错误，请检查网络连接'));
        });

        xhr.addEventListener('timeout', () => {
          reject(new Error('上传超时，请重试'));
        });

        xhr.timeout = 120000; // 2分钟超时
        xhr.open('POST', 'api/xzxzs/api/wx/hdmi/material/add');
        xhr.send(formData);
      });
    },
    // 检测设备类型
    detectDevice() {
      const ua = navigator.userAgent.toLowerCase();
      this.isAndroid = ua.indexOf('android') > -1;
      if (this.isAndroid) {
        // console.log('安卓设备');
      } else if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
        // console.log('iOS设备');
      } else {
        // console.log('其他设备');
      }
    },
    onCancelScreenMeta() {
      this.materialObj = {};
      this.screenDuration = '';
      // this.playbackVolume = 0;
      this.showAddFlag = false;
      this.showMaterialValueParams = this.SingleNameList[0];
      this.showReviewValueParams = this.AdmitNameList[0];
    },
    onAddScreenMeta() {
      if (!this.screenDuration) {
        this.$toast('请输入播放时长！');
        return false;
      }
      if (this.materialObj.type !== 'PICTURE') {
        if (this.playbackVolume < 1) {
          this.$toast('请设置播放音量');
          return false;
        }
      }
      this.$http.wx_hdmi_plan_material_add({
        id: this.programItem.programPlanId,
        materialId: this.materialObj.id,
        type: this.materialObj.type,
        duration: this.screenDuration,
        volume: this.playbackVolume,
      }).then((res) => {
        if (res) {
          if (res.code === 200) {
            this.$toast.success('添加素材成功！');
            this.showAddFlag = false;
            this.getItemList(this.screenList[this.programTabIndex].value);
          } else {
            this.$toast.fail(res.message);
            return false;
          }
        }
      });
    },
    // // 节目单添加素材
    // programAdditions(item){
    //   this.$http.wx_hdmi_plan_material_add({
    //     id: this.programItem.programPlanId,
    //     materialId:item.id,
    //     duration:90,
    //     volume:30,
    //   }).then((res)=>{
    //     if(res){
    //       if(res.code===200){
    //         this.$toast('添加素材成功！');
    //         this.getItemList(this.screenList[this.programTabIndex].value);
    //       }else{
    //         this.$toast.fail(res.message);
    //         return false;
    //       }
    //     }
    //   });
    // },
    // //   节目单添加素材
    // async programAddition(item) {
    //   // this.subDisabled = true;
    //   // this.isUploading = true;
    //   // this.uploadProgress = 0;
    //   try {
    //     // 创建FormData对象
    //     const formData = new FormData();
    //     formData.append('id', this.programItem.programPlanId);
    //     formData.append('materialId', item.id);
    //     formData.append('duration', '50');//item.value
    //     formData.append('volume', '30');//this.playbackVolume
    //
    //     // formData.append('contents[0].file', this.fileObject); // 文件对象
    //     // formData.append('contents[0].fileName', this.fileObject.name); // 文件对象
    //     // formData.append('contents[0].fileSize', this.fileObject.size); // 文件对象
    //     // formData.append('contents[0].width', this.width); // 文件对象
    //     // formData.append('contents[0].height', this.height); // 文件对象
    //     // console.log(formData)
    //     await this.getCheckboxAdd(formData);
    //     // // 安卓设备特殊处理
    //     // if (this.isAndroid) {
    //     //   // 新增
    //     //   if (!this.editCustomizeParams.id) {
    //     //     await this.uploadForAndroid(formData);
    //     //   }else{
    //     //     // 修改
    //     //     formData.append('id', this.editCustomizeParams.id);
    //     //     await this.uploadForAndroidUpdate(formData);
    //     //   }
    //     // } else {
    //     //   // 新增
    //     //   if (!this.editCustomizeParams.id) {
    //     //     await this.uploadStandard(formData);
    //     //   }else{
    //     //     // 修改
    //     //     formData.append('id', this.editCustomizeParams.id);
    //     //     await this.uploadStandardUpdate(formData);
    //     //   }
    //     // }
    //     // this.isUploading = false;
    //     // this.subDisabled = false;
    //   } catch (error) {
    //     console.log(error,'节目单')
    //     // this.isUploading = false;
    //     // this.subDisabled = false;
    //     // this.handleUploadError(error);
    //   }
    // },
    // getCheckboxAdd(formData){
    //   return new Promise((resolve, reject) => {
    //     // 使用更简单的配置，避免安卓兼容性问题
    //     const xhr = new XMLHttpRequest();
    //     xhr.addEventListener('load', () => {
    //       if (xhr.status >= 200 && xhr.status < 300) {
    //         // 成功响应
    //         let response = JSON.parse(xhr.response)
    //         if (response) {
    //           if (response.code === 200) {
    //             console.log(response)
    //           } else {
    //             this.$toast.fail(response.message);
    //             return false;
    //           }
    //         }
    //         resolve({ data: 'success' });
    //       } else {
    //         reject(new Error(`上传失败: ${xhr.status}`));
    //       }
    //     });
    //
    //     xhr.addEventListener('error', () => {
    //       reject(new Error('网络错误，请检查网络连接'));
    //     });
    //
    //     xhr.addEventListener('timeout', () => {
    //       reject(new Error('上传超时，请重试'));
    //     });
    //
    //     xhr.timeout = 120000; // 2分钟超时
    //     xhr.open('POST', 'api/xzxzs/api/wx/hdmi/plan/material/add');
    //     xhr.send(formData);
    //   });
    // }
  },
  created() {
    // 检测设备类型，如：安卓或ios
    this.detectDevice();
    // 网点编号
    if (this.$route.query.sid) {
      this.siteId = this.$route.query.sid;
      let localSiteId = getLocalItem('siteIdLocal');
      if (localSiteId) {
        if (this.siteId !== localSiteId) {
          setLocalItem('siteIdLocal', this.siteId);
          delLocalItem('inPlayListArr');
        }
      } else {
        setLocalItem('siteIdLocal', this.siteId);
        delLocalItem('inPlayListArr');
      }
      // this.typeTabIndex !== 1 ? 'General' : 'Personal'
      if (this.typeTabIndex === 0) {
        this.SingleNameList = [
          // {type:'', name: '全部类型'},
          {type: 'PICTURE', name: '图片'},
          {type: 'VIDEO', name: '视频'},
          {type: 'URL', name: '网页'},
          {type: 'PLUGIN', name: '插件'},
        ]
      } else {
        this.SingleNameList = [
          {type: '', name: '全部类型'},
          {type: 'PICTURE', name: '图片'},
          {type: 'VIDEO', name: '视频'},
        ]
      }
      this.showMaterialValueParams = this.SingleNameList[0];
      this.showReviewValueParams = this.AdmitNameList[0];
    } else {
      this.$toast('无网点编号！');
    }
  }
}
</script>
<template>
  <div class="wrap">
    <!--  主体内容布局开始  -->
    <div class="tabs">
      <van-tabs v-model="activeTab" @change="onHeadTab" animated swipeable sticky>
        <van-tab title="素材" name="0"></van-tab>
        <van-tab title="节目单" name="1"></van-tab>
        <!--        <van-tab title="设置" name="2"></van-tab>-->
      </van-tabs>
    </div>
    <div class="tab-content">
      <div v-if="activeTab==='0'" class="content-box">
        <div class="card-title">
          🎨{{ typeTab[typeTabIndex].text }}
          <span class="btn-span" v-if="typeTabIndex===1" @click="getShowMeta"><van-icon name="plus"/>上传素材</span>
        </div>
        <div class="tabs-style">
          <van-tabs v-model="typeTabIndex" :before-change="onTabCurrent">
            <van-tab v-for="(item,index) in typeTab" :key="index" :title="' '+index">
              <template #title v-if="item.name">
                <div v-if="item.name" style="display: flex;align-items: center">
                  <van-icon :name="item.icon" class="icon-style"/>
                  {{ item.name }}
                  <span class="num-style" v-if="item.number>0">{{ item.number }}</span>
                </div>
              </template>
            </van-tab>
          </van-tabs>
        </div>
        <div class="choice-box">
          <div class="">
            <div class="list-data">
              <!-- 素材筛选条件 -->
              <div class="filter-section">
                <div class="filter-row">
                  <div class="filter-group" v-if="typeTabIndex===0">
                    <label class="filter-label">搜索</label>
                    <van-field class="search-text" type="text" v-model="searchInput"
                               placeholder="🔍 搜索素材名称..."></van-field>
                  </div>
                  <div class="filter-group" v-if="typeTabIndex===1">
                    <label class="filter-label">审核状态</label>
                    <van-field
                        v-model="showReviewValueParams.name"
                        name=""
                        label=""
                        readonly="readonly"
                        placeholder="请选择审核状态"
                        @click="showReviewFlag=true"
                    >
                      <template #right-icon>
                        <van-icon name="arrow-down"/>
                      </template>
                    </van-field>
                  </div>
                  <div class="filter-group">
                    <label class="filter-label">素材类型</label>
                    <van-field
                        v-model="showMaterialValueParams.name"
                        name=""
                        label=""
                        readonly="readonly"
                        placeholder="请选择素材类型"
                        @click="showMaterialFlag=true"
                    >
                      <template #right-icon>
                        <van-icon name="arrow-down"/>
                      </template>
                    </van-field>
                  </div>
                </div>
              </div>
              <!--素材列表-->
              <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt"
                        :immediate-check="false" @load="onLoad">
                <div class="material-list" v-if="medaListData.length>0">
                  <div class="material-item new-item" v-for="(item,index) in medaListData" :key="index">
                    <div class="material-icon">{{ icons[item.type] }}</div>
                    <div class="material-info">
                      <div class="material-name">{{ item.name }}
                        <span :class="item.usageType === 'General'?'gGeneral':'pPersonal'">{{
                            item.usageType === 'General' ? '官方' : '自定义'
                          }}</span>
                      </div>
                      <div class="material-meta">{{ item.description }}</div>
                      <div class="material-meta">{{ iconsName[item.type] }}{{ item.horizontalUrl ? ` · 横屏` : `` }}
                        {{ item.verticalUrl ? ` · 竖屏` : `` }}
                      </div>
                      <div class="material-meta">{{ item.createTime }}</div>
                    </div>
                    <div class="material-icon-evolve" v-if="item.usageType !== 'General'">
                      <div class="status-evolve pass-icon"
                           v-if="item.review&&item.review.status==='Pass'">
                        <van-icon name="checked"/>
                        已通过
                      </div>
                      <div class="status-evolve pending-icon"
                           v-else-if="item.review&&item.review.status==='Pending'">
                        ⏳ 待审核
                      </div>
                      <div class="status-evolve failed-icon"
                           v-else-if="item.review&&item.review.status==='Failed'">
                        ❌ 已驳回
                      </div>
                      <div class="m-a-t">
                        <span class="edit-evolve" v-if="item.review&&item.review.status!=='Pass'"
                              @click="onEditFigureItem(item)"><van-icon name="edit"/></span>
                        <span class="del-evolve" @click="onDeleteFigure(item)"><van-icon name="delete"/></span>
                      </div>
                    </div>
                    <div v-else></div>
                  </div>
                </div>
                <!--暂无素材-->
                <div class="empty-state" v-else>
                  <div class="empty-icon">{{ icons['allIcon'] }}</div>
                  <div class="empty-text">暂无数据</div>
                </div>
              </van-list>
            </div>
          </div>
        </div>
      </div>
      <div v-if="activeTab==='1'" class="content-box">
        <div class="card-title">
          📺️节目单管理
        </div>
        <div class="tabs-style">
          <van-tabs v-model="programTabIndex" scrollable :before-change="onProgramTabCurrent">
            <van-tab v-for="(item,index) in screenList" :key="index" :title="' '+index">
              <template #title>
                <div class="infant">
                  <van-icon name="tv-o" class="vanish"/>
                  {{ item.label }}
                </div>
              </template>
            </van-tab>
          </van-tabs>
          <div class="screen-group">
            <div class="" v-if="programListObj.length>0">
              <div class="screen-card" v-for="(item,index) in programListObj" :key="index">
                <div class="screen-header">
                  <div class="screen-name">
                    <van-icon name="tv-o" class="vanish"/>
                    {{ item.programPlanName }}
                  </div>
                  <div class="screen-upright">
                    是否直播：
                    <van-switch v-model="item.logCheck" :disabled="item.typical==='System'"
                                @change="() => getOnUpSwitch(item)" size="24px" active-color="#ee0a24"
                                inactive-color="#dcdee0"/>
                  </div>
                </div>
                <div class="screen-card-box">
                  <div class="material-list-auto" v-if="item.programs.length>0">
                    <div class="material-item-auto" v-for="(v,k) in item.programs" :key="k">
                      <div class="material-icon-auto">{{ icons[v.type] }}</div>
                      <div class="material-info-auto">
                        <div class="material-name-auto">{{ v.name }}</div>
                        <div class="material-meta">
                          {{ iconsName[v.type] }} ·
                          时长：<span class="red">{{ v.duration }}s</span>
                          <span v-show="v.type!=='PICTURE'"> · 音量：<span class="red">{{ v.volume }}%</span></span>
                        </div>
                      </div>
                      <div class="playlist-controls" v-if="item.typical!=='System'">
                        <span class="order-btn order-btn-disabled" v-if="k===type1Count">▲</span>
                        <span class="order-btn" v-else @click="getOnMoveUp(item,v,k)">▲</span>
                        <span class="order-btn" v-if="item.programs.length>(k+1)"
                              @click="getOnMoveDown(item,v,k)">▼</span>
                        <span class="order-btn order-btn-disabled" v-else>▼</span>
                      </div>
                      <div class="material-icon-evolve" v-if="item.typical!=='System'">
                        <div class="m-a-t">
                          <span class="edit-evolve" @click="onEditScreenItem(v)"><van-icon name="edit"/></span>
                          <span class="del-evolve" @click="onDeleteScreenItem(v)"><van-icon name="delete"/>️</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="empty-state" v-else>
                    <div class="empty-icon">{{ icons[typeTab[typeTabIndex].type] }}</div>
                    <div class="empty-text">暂无素材，请添加素材到节目单</div>
                  </div>
                </div>
                <div class="flex-button" v-if="item.typical!=='System'">
                  <div style="display: flex; gap: 8px;">
                    <button class="btn-mini btn-outline" @click="getEditGroupScreen(item)">
                      <!--                    <van-icon name="records" />-->编辑
                    </button>
                    <button class="btn-mini btn-outline" @click="getDelGroupScreen(item)">
                      <!--                    <van-icon name="delete" />-->删除
                    </button>
                    <button class="btn-mini btn-outline" @click="getBoxProgramPush(item)">
                      推送
                    </button>
                  </div>
                  <div style="display: flex; gap: 8px;" v-if="item.typical!=='System'">
                    <button class="btn-mini btn-primary" @click="addMate(item)">
                      <!--                    <van-icon name="plus" />-->添加素材
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- 无节目单 -->
            <div class="screen-card" v-if="programListObj.length<2">
              <div class="screen-header" style="justify-content: flex-end">
                <div class="card-title">
                  <span class="btn-span" @click="getAddScreenMeta"><van-icon name="plus"/>添加节目单</span>
                </div>
              </div>
              <div class="empty-state">
                <div class="empty-icon">{{ icons['allIcon'] }}</div>
                <div class="empty-text">请添加节目单</div>
              </div>
            </div>
          </div>
          <!--  无盒子   -->
          <div class="screen-group" v-if="screenList.length===0">
            <div class="screen-card">
              <div class="screen-header" style="justify-content: flex-end">
                <div class="card-title"></div>
              </div>
              <div class="empty-state">
                <div class="empty-icon">{{ icons['allIcon'] }}</div>
                <div class="empty-text">暂无数据</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="activeTab==='2'" class="content-box">
        <div class="card-title">
          ⚙️屏幕设置
          <span class="btn-span" @click="getAddScreenMeta"><van-icon name="plus"/>添加屏幕</span>
        </div>
        <div class="tabs-style">
          <div class="screen-group">
            <div class="screen-card" v-for="(item,index) in screenList" :key="index">
              <div class="screen-header">
                <div class="screen-name">
                  <van-icon name="tv-o" class="vanish"/>
                  {{ item.label }}
                </div>
                <div class="index-num">{{ index + 1 }}</div>
              </div>
              <div class="screen-card-box">
                <div class="screen-card-pad">
                  <div class="form-label">
                    屏幕名称
                  </div>
                  <div class="form-commit">
                    <van-field
                        v-model="item.label"
                        name="title"
                        label=""
                        type="text"
                        autocomplete="off"
                        placeholder="请输入新屏幕名称"
                    />
                  </div>
                  <div class="form-label" style="margin-top: 10px;">屏幕方向</div>
                  <div class="form-commit">
                    <van-radio-group v-model="item.type" direction="horizontal">
                      <van-radio :name="val.label" v-for="(val,k) in item.values" :key="k">
                        {{ val.label }}
                      </van-radio>
                    </van-radio-group>
                  </div>
                </div>
              </div>
              <div class="flex-button">
                <div style="display: flex; gap: 8px;">
                  <button class="btn-mini btn-primary" @click="getScreenSave(item)">
                    <van-icon name="records"/>
                    保存
                  </button>
                  <button class="btn-mini btn-outline" style="color:#e62d2d;border-color: #e62d2d">
                    <van-icon name="delete"/>
                    删除
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  自定义素材上传弹窗 -->
    <van-popup v-model="customizeMaterialsFlag" round position="center" :close-on-click-overlay="false"
               :style="{width:'80%' }">
      <div class="inner-diag">
        <div class="title-had">
          <div class="fixed-close" @click="getCancel">&times;</div>
          <div class="section-title">{{ editCustomizeParams.id ? '编辑素材' : '上传自定义素材' }}</div>
        </div>
        <div class="tabs-group">
          <div class="upload-requirements">
            <div class="req-title">📋 上传要求：</div>
            <div class="req-content">
              <div>✓ 视频：<!--MP4、MOV格式，--> ≤500MB，≤3分钟</div>
              <div>✓ 图片：JPG/PNG格式，≤5MB</div>
              <div>✓ 上传后需等待审核，审核通过后可使用</div>
            </div>
          </div>
          <div class="form-label">素材类型 <span style="color: #e62d2d;">*</span></div>
          <div class="form-commit">
            <van-radio-group v-model="showCustomValueParams.name" direction="horizontal">
              <van-radio :name="val.name" v-for="(val,k) in listCustomTypeData" :key="k">
                {{ val.name }}
              </van-radio>
            </van-radio-group>
          </div>
          <div class="form-label">素材标题 <span style="color: #e62d2d;">*</span></div>
          <div class="form-commit">
            <van-field
                v-model="editCustomizeParams.name"
                name="name"
                label=""
                type="text"
                autocomplete="off"
                placeholder="请输入素材标题（如：春节宣传视频）"
            />
          </div>
          <!--        <div class="form-label">素材描述 <span style="color: #e62d2d;">*</span></div>-->
          <!--        <div class="form-commit">-->
          <!--          <van-field-->
          <!--              v-model="editCustomizeParams.description"-->
          <!--              name="name"-->
          <!--              label=""-->
          <!--              type="textarea"-->
          <!--              autocomplete="off"-->
          <!--              placeholder="请输入素材描述（如：用于春节期间的宣传展示）"-->
          <!--          />-->
          <!--        </div>-->
          <div class="form-label">屏幕方向 <span style="color: #e62d2d;">*</span></div>
          <div class="form-commit">
            <van-radio-group v-model="radioTypeValue.name" direction="horizontal">
              <van-radio :name="val.name" v-for="(val,k) in radioTypeLists" :key="k">
                {{ val.name }}
              </van-radio>
            </van-radio-group>
          </div>
          <div class="form-label">选择文件 <span style="color: #e62d2d;">*</span></div>
          <div class="group-video">
            <div class="group-video-load">
              <div class="post-video"
                   v-if="fileList&&fileList[0]&&fileList[0].url&&(fileList[0].url.indexOf('.mp4')!==-1||fileList[0].url.indexOf('.mov')!==-1)">
                <video :src="fileList[0].url"></video>
              </div>
              <div class="post-video" v-if="fileVideoShowUrl&&fileList">
                <video ref="videoPreview" :src="fileVideoShowUrl"></video>
              </div>
              <!--            安卓手机，视频文件上传-->
              <div class="upload-area" v-if="isAndroid&&showCustomValueParams.name==='视频'&&fileList.length===0">
                <div class="icon-calm">
                  <van-icon name="photograph"/>
                </div>
                <input type="file"
                       class="file-input"
                       ref="fileInput"
                       accept="video/*"
                       @change="onFileChange"/>
              </div>
              <van-uploader v-model="fileList" v-else :max-count="1" accept="image,video" :before-delete="getReadDelete"
                            :after-read="afterRead" :before-read="beforeRead"/>
            </div>
          </div>
          <div class="">
            <div class="progress-container" :class="{ 'active': isUploading }">
              <div class="progress-info">
                <span>上传进度</span>
                <span>{{ uploadProgress }}%</span>
              </div>
              <div class="progress-bar">
                <div class="progress-fill" :style="{ width: uploadProgress + '%' }"></div>
              </div>
            </div>
          </div>
        </div>
        <div class="form-buttons">
          <van-button round block plain type="default" @click="getCancel">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" :disabled="subDisabled" @click="onAddFigure">上传
          </van-button>
        </div>
      </div>
    </van-popup>
    <!--  审核类型 -->
    <van-popup v-model="showReviewFlag" position="bottom">
      <van-picker
          show-toolbar
          title="审核类型"
          :columns="AdmitNameList"
          value-key="name"
          :default-index="0"
          @confirm="onReviewType"
          @cancel="showReviewFlag = false"
      />
    </van-popup>
    <!--  素材类型 -->
    <van-popup v-model="showMaterialFlag" position="bottom">
      <van-picker
          show-toolbar
          title="素材类型"
          :columns="SingleNameList"
          value-key="name"
          @confirm="onMaterialType"
          @cancel="showMaterialFlag = false"
      />
    </van-popup>
    <!--  编辑播放设置  -->
    <van-popup v-model="showCustomTypeFlag" round position="center" :close-on-click-overlay="false"
               :style="{width:'80%' }">
      <div class="inner-diag">
        <div class="title-had">
          <div class="fixed-close" @click="getScreenCancel">&times;</div>
          <div class="section-title">编辑播放设置</div>
        </div>
        <div class="tabs-group">
          <div class="form-label">素材标题</div>
          <div class="form-commit">
            <van-field
                v-model="objScreenItem.name"
                name="name"
                label=""
                type="text"
                readonly
                autocomplete="off"
                placeholder="请输入素材标题（如：春节宣传视频）"
            />
          </div>
          <div class="form-label">播放时长</div>
          <div class="form-commit">
            <van-field
                v-model="objScreenItem.duration"
                name="name"
                label=""
                type="number"
                autocomplete="off"
                placeholder="请填写播放时长"
            />
          </div>
          <div class="form-label" v-show="objScreenItem.type!=='PICTURE'">播放音量</div>
          <div class="switch-line" v-show="objScreenItem.type!=='PICTURE'">
            <div class="line-box">
              <el-slider v-model="playbackVolume" :show-tooltip="false"></el-slider>
            </div>
            <div class="line-number"><span>{{ playbackVolume }}</span>%</div>
          </div>
        </div>
        <div class="form-buttons">
          <van-button round block plain type="default" @click="getScreenCancel">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" @click="onAddScreen">确定</van-button>
        </div>
      </div>
    </van-popup>
    <!-- 添加节目单 -->
    <van-popup v-model="showMaterialOfficialFlag" round position="center" :close-on-click-overlay="false"
               :style="{width:'80%' }">
      <div class="inner-diag">
        <div class="title-had">
          <div class="fixed-close" @click="getScreenNameCancel">&times;</div>
          <div class="section-title">{{ !programItem.programPlanId ? '添加' : '编辑' }}节目单</div>
        </div>
        <div class="tabs-group">
          <div class="form-label">节目单名称</div>
          <div class="form-commit">
            <van-field
                v-model="programTitle"
                name="name"
                label=""
                type="text"
                autocomplete="off"
                placeholder="请输入节目单名称"
            />
          </div>
          <div class="form-label">开启直播</div>
          <div class="form-commit">
            <van-radio-group v-model="liveState" direction="horizontal">
              <van-radio :name="val.type" v-for="(val,k) in liveArrayState" :key="k">
                {{ val.name }}
              </van-radio>
            </van-radio-group>
            <!--          <van-switch v-model="liveState" size="24px" active-color="#ee0a24" inactive-color="#dcdee0"/>-->
          </div>
          <div class="form-label">播放音量</div>
          <div class="switch-line">
            <div class="line-box">
              <el-slider v-model="liveBackVolume" :show-tooltip="false"></el-slider>
            </div>
            <div class="line-number"><span>{{ liveBackVolume }}</span>%</div>
          </div>
        </div>
        <div class="form-buttons">
          <van-button round block plain type="default" @click="getScreenNameCancel">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" @click="getScreenNameAdd">确定</van-button>
        </div>
      </div>
    </van-popup>
    <!--    添加素材-->
    <van-popup v-model="showAddFlag" round position="center" :close-on-click-overlay="false"
               :style="{width:'88%',height:'95%' }">
      <div class="inner-diag">
        <div class="title-had">
          <div class="fixed-close" @click="onCancelScreenMeta">&times;</div>
          <div class="section-title">添加素材</div>
        </div>
        <div class="tabs-group list-box-tip">
          <div class="aerial-up">
            <div class="tabs-style">
              <van-tabs v-model="typeTabIndex" :before-change="onTabCurrent">
                <van-tab v-for="(item,index) in typeTab" :key="index" :title="' '+index">
                  <template #title v-if="item.name">
                    <div v-if="item.name" style="display: flex;align-items: center">
                      <van-icon :name="item.icon" class="icon-style"/>
                      {{ item.name }}
                      <span class="num-style" v-if="item.number>0">{{ item.number }}</span>
                    </div>
                  </template>
                </van-tab>
              </van-tabs>
            </div>
            <!-- 素材筛选条件 -->
            <div class="filter-section">
              <div class="filter-row">
                <div class="filter-group">
                  <label class="filter-label">搜索</label>
                  <van-field class="search-text" type="text" v-model="searchInput"
                             placeholder="🔍 搜索素材名称..."></van-field>
                </div>
                <!--              <div class="filter-group">-->
                <!--                <label class="filter-label">审核状态</label>-->
                <!--                <van-field-->
                <!--                    v-model="showReviewValueParams.name"-->
                <!--                    name=""-->
                <!--                    label=""-->
                <!--                    readonly="readonly"-->
                <!--                    placeholder="请选择审核状态"-->
                <!--                    @click="showReviewFlag=true"-->
                <!--                >-->
                <!--                  <template #right-icon>-->
                <!--                    <van-icon name="arrow-down"/>-->
                <!--                  </template>-->
                <!--                </van-field>-->
                <!--              </div>-->
                <div class="filter-group">
                  <label class="filter-label">素材类型</label>
                  <van-field
                      v-model="showMaterialValueParams.name"
                      name=""
                      label=""
                      readonly="readonly"
                      placeholder="请选择素材类型"
                      @click="showMaterialFlag=true"
                  >
                    <template #right-icon>
                      <van-icon name="arrow-down"/>
                    </template>
                  </van-field>
                </div>
              </div>
            </div>
            <div class="form-label">播放时长</div>
            <div class="form-commit">
              <van-field
                  v-model="screenDuration"
                  name="name"
                  label=""
                  type="number"
                  autocomplete="off"
                  placeholder="请填写播放时长"
              />
            </div>
            <div class="form-label" v-if="showMaterialValueParams.type!=='PICTURE'">播放音量</div>
            <div class="switch-line" v-if="showMaterialValueParams.type!=='PICTURE'">
              <div class="line-box">
                <el-slider v-model="playbackVolume" :show-tooltip="false"></el-slider>
              </div>
              <div class="line-number"><span>{{ playbackVolume }}</span>%</div>
            </div>
          </div>
          <div class="list-add-data">
            <van-list v-model="loading1" :finished="finished1" :finished-text="finishedMsgTxt" :immediate-check="false"
                      @load="onLoad">
              <div class="material-list-auto" v-if="medaListData.length>0">
                <div class="material-item-auto" v-for="(item,index) in medaListData" :key="index">
                  <div class="material-icon-auto">{{ icons[item.type] }}</div>
                  <div class="material-info-auto">
                    <div class="material-name-auto">
                      {{ item.name }}
                      <span :class="item.usageType === 'General'?'gGeneral':'pPersonal'">
                      {{ item.usageType === 'General' ? '官方' : '自定义' }}
                    </span>
                    </div>
                    <div class="material-meta">{{ item.description }}</div>
                    <div class="material-meta">{{ iconsName[item.type] }}{{ item.horizontalUrl ? ` · 横屏` : `` }}
                      {{ item.verticalUrl ? ` · 竖屏` : `` }}
                    </div>
                    <div class="material-meta">{{ item.createTime }}</div>
                  </div>
                  <div class="material-switch">
                    <button v-model="item.checked" class="check-btn" :disabled="item.enable" @click="getOnSwitch(item)">
                    <span class="check-box-group" :class="item.checked?'checked':''">
                      <van-icon name="success" v-show="item.checked"/>
                    </span>
                      <!--                    {{item.enable?'禁选':(item.checked?'已选':'可选')}}-->
                    </button>
                  </div>
                </div>
              </div>
              <!--暂无素材-->
              <div class="empty-state" v-else>
                <div class="empty-icon">{{ icons['allIcon'] }}</div>
                <div class="empty-text">暂无数据</div>
              </div>
            </van-list>
          </div>

        </div>
        <div class="form-buttons">
          <van-button round block plain type="default" @click="onCancelScreenMeta">取消</van-button>
          <van-button round block type="primary" color="#e62d2d" @click="onAddScreenMeta">确定</van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<style scoped lang="scss">
.wrap {
  display: flex;
  flex-direction: column;
  background: #f8f9fd;
  min-height: calc(100vh - 92px);
  width: 100%;
  overflow-x: hidden;

  .tabs {
    display: flex;
    height: 86px;
    overflow-x: hidden;
  }

  .tab-content {
    display: flex;
    flex-direction: column;
    padding: 0 20px 20px;
    box-sizing: border-box;

    .content-box {
      display: flex;
      flex-direction: column;

      .tabs-style {
        display: flex;
        flex-direction: column;
        //margin-bottom: 20px;
        height: 70px;

        .infant {
          font-size: 26px;
          margin-right: 5px;
          display: flex;
          align-items: center;
          justify-content: center;

          .vanish {
            margin-right: 4px;
          }
        }

        /deep/ .van-tabs {
          height: 100%;
        }

        /deep/ .van-tabs__wrap {
          height: 100%;
        }

        /deep/ .van-tabs--line {
          height: 100%;
        }

        /deep/ .van-tabs__nav {
          background: transparent;

        }

        /deep/ .van-tabs__wrap {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }

        /deep/ .van-tabs__nav {
          flex-wrap: nowrap;
          min-width: 100%;
        }

        /deep/ .van-tabs__nav--complete {
          padding-left: 0;
        }

        /deep/ .van-tab {
          margin-right: 20px;
          border-radius: 50px;
          background: #fff;
          padding: 0 30px;
          border: 2px solid #eee;
        }

        /deep/ .van-tab__text {
          font-size: 24px;
          min-width: 150px;
        }

        /deep/ .van-tab--active {
          border-radius: 50px;
          background: #e62d2d;
          color: #fff;

          .num-style {
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            background: #c11f1f;
            height: 50px;
            min-width: 50px;
          }
        }

        /deep/ .van-tabs__line {
          height: 0;
        }

        .icon-style {
          font-size: 28px;
          margin-right: 5px;
        }

        .num-style {
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          padding: 3px 10px;
          font-size: 24px;
          color: #555;
          margin-left: 4px;
          background: rgba(0, 0, 0, 0.1);
          height: 50px;
          min-width: 50px;
        }

        .screen-group {
          margin-top: 20px;
          display: flex;
          flex-flow: column;
          /* 屏幕卡片 */
          .screen-card {
            display: flex;
            flex-flow: column;
            background: #fff;
            border-radius: 16px;
            margin-bottom: 20px;
            overflow: hidden;
            border: 1px solid rgba(231, 76, 60, 0.08);
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);
            transition: all 0.3s ease;
          }

          .screen-card-box {
            padding: 0 20px 20px;

            .screen-card-pad {
              padding: 20px 0 0;
            }

            .material-list-auto {
              margin-top: 12px;

              .material-item-auto {
                display: flex;
                align-items: center;
                padding: 12px 12px 12px 4px;
                border-radius: var(--radius-sm);
                margin-top: 16px;
                box-shadow: 0 5px 12px rgba(0, 0, 0, 0.10);
                background: #fff;

                .material-icon-auto {
                  width: 60px;
                  height: 60px;
                  background-color: #e0e0e0;
                  border-radius: var(--radius-sm);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 42px;
                  margin-left: 8px;
                  margin-right: 12px;
                  flex-shrink: 0;
                }


                .material-info-auto {
                  flex: 1;
                  padding: 0 0 0 10px;

                  .material-name-auto {
                    font-size: 28px;
                    font-weight: 500;
                    margin-bottom: 4px;
                    word-break: break-word;

                    span {
                      padding: 4px;
                      font-size: 22px;
                    }

                  }

                  .material-meta {
                    font-size: 24px;
                    color: #7f8c8d;

                    span {

                      font-size: 24px;
                    }

                    .red {
                      font-weight: bold;
                      color: #e62d2d;
                    }
                  }
                }

                .playlist-controls {
                  display: flex;
                  flex-direction: column;
                  gap: 4px;
                  margin-left: auto;
                  margin-right: 8px;

                  .order-btn {
                    width: 48px;
                    height: 48px;
                    background-color: white;
                    border: 1px solid var(--border-color);
                    border-radius: 6px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s;
                    font-size: 18px;
                    color: var(--text-secondary);
                  }

                  .order-btn:active {
                    background-color: var(--secondary-color);
                    border-color: var(--primary-color);
                    color: var(--primary-color);
                  }

                  .order-btn-disabled {
                    opacity: 0.3;
                    cursor: not-allowed;
                  }
                }


                .material-icon-evolve {
                  display: flex;
                  flex-direction: column;
                  align-items: flex-end;
                  gap: 8px;

                  .m-a-t {
                    display: flex;
                    flex-direction: row;

                    .edit-evolve {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      padding: 10px 10px;
                      margin-left: 10px;
                      border-radius: 12px;
                      cursor: pointer;
                      transition: all 0.2s;
                      font-size: 35px;
                      color: #7f8c8d;
                    }

                    .del-evolve {
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      padding: 10px 10px;
                      margin-left: 10px;
                      border-radius: 12px;
                      transition: all 0.2s;
                      font-size: 35px;
                      color: #7f8c8d;
                    }
                  }

                  .status-evolve {
                    display: inline-flex;
                    padding: 3px 10px;
                    border-radius: 12px;
                    font-weight: 500;
                    align-items: center;
                    gap: 4px;
                  }

                  .pass-icon {
                    background: #e8f5e8;
                    color: #4caf50;
                  }

                  .pending-icon {
                    background-color: #fff3e0;
                    color: #ff9800;
                  }

                  .failed-icon {
                    background-color: #ffebee;
                    color: #f44336;
                  }

                }
              }
            }
          }

          .screen-header {
            background: linear-gradient(135deg, rgba(231, 76, 60, 0.08) 0%, rgba(192, 57, 43, 0.08) 100%);
            padding: 25px 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .vanish {
              margin-right: 4px;
            }
          }

          .index-num {
            display: flex;
            background: #e62d2d;
            color: white;
            border-radius: 50%;
            min-width: 50px;
            height: 50px;
            font-size: 24px;
            align-items: center;
            justify-content: center;
          }

          .screen-name {
            font-weight: 500;
            color: var(--text-primary);
          }

          .screen-upright {
            display: flex;
            flex-flow: row;
            color: #666;
          }

          .screen-index-num {
            display: flex;
            border-radius: 34px;
            font-size: 24px;
            align-items: center;
            justify-content: center;
            padding: 10px 20px;
            font-weight: bold;
            color: var(--primary-color);
            background: rgba(231, 76, 60, 0.1);
          }

          .flex-button {
            padding: 26px 20px;
            border-top: 1px solid rgba(231, 76, 60, 0.08);
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: linear-gradient(135deg, rgba(231, 76, 60, 0.02) 0%, rgba(192, 57, 43, 0.02) 100%);
          }


          /* 按钮样式 */
          .btn-mini {
            padding: 12px 36px;
            border-radius: 6px;
            border: none;
            transition: all 0.2s;
            cursor: pointer;
            display: inline-flex;
            align-items: center;
            gap: 6px;
          }

          .btn-primary {
            background: var(--primary-color);
            color: white;
          }

          .btn-primary:active {
            background: #c0392b;
            transform: scale(0.95);
          }

          .btn-outline {
            background: transparent;
            border: 3px solid var(--border-color);
            color: var(--text-primary);
          }

          .btn-outline:active {
            background: #f5f5f5;
          }
        }
      }
    }

    .material-list {
      margin-top: 12px;

      .material-item {
        display: flex;
        align-items: center;
        padding: 12px;
        border-radius: var(--radius-md);
        margin-bottom: 18px;
        background: #fff;

        .material-icon {
          width: 60px;
          height: 60px;
          background-color: #e0e0e0;
          border-radius: var(--radius-sm);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 42px;
          margin-left: 12px;
          margin-right: 12px;
          flex-shrink: 0;
        }

        .material-info {
          flex: 1;
          padding: 0 20px;

          .material-name {
            font-size: 28px;
            font-weight: 500;
            margin-bottom: 4px;
            word-break: break-word;

            span {
              padding: 4px;
              font-size: 22px;
            }

            .gGeneral {
              background-color: #e3f2fd;
              color: #1976d2;
            }

            .pPersonal {
              background-color: #fff2fd;
              color: #ff9800;
            }
          }

          .material-meta {
            font-size: 24px;
            color: #7f8c8d;

            span {

              font-size: 24px;
            }

            .red {
              font-weight: bold;
              color: #e62d2d;
            }
          }
        }

        .material-icon-evolve {
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 8px;

          .m-a-t {
            display: flex;
            flex-direction: row;

            .edit-evolve {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 10px 10px;
              margin-left: 10px;
              border-radius: 12px;
              cursor: pointer;
              transition: all 0.2s;
              font-size: 35px;
              color: #7f8c8d;
            }

            .del-evolve {
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 10px 10px;
              margin-left: 10px;
              border-radius: 12px;
              transition: all 0.2s;
              font-size: 35px;
              color: #7f8c8d;
            }
          }

          .status-evolve {
            display: inline-flex;
            padding: 3px 10px;
            border-radius: 12px;
            font-weight: 500;
            align-items: center;
            gap: 4px;
          }

          .pass-icon {
            background: #e8f5e8;
            color: #4caf50;
          }

          .pending-icon {
            background-color: #fff3e0;
            color: #ff9800;
          }

          .failed-icon {
            background-color: #ffebee;
            color: #f44336;
          }

        }
      }
    }

    .new-item {
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
    }

    .checked-item {
      background: #e6a23c;
    }
  }
}

.empty-state {
  display: flex;
  width: 100%;
  background: #fff;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding: 60px 20px;
  color: var(--text-light);

  .empty-icon {
    font-size: 68px;
    margin-bottom: 12px;
  }

  .empty-text {
    font-size: 24px;
  }
}

.share-show {
  border-radius: var(--radius-md);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.inner-diag {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  box-sizing: border-box;
  border-radius: 30px;

  .title-had {
    position: fixed;
    left: 0;
    top: 0;
    z-index: 19;
    height: 100px;
    width: 100%;
    padding: 30px 30px 0;
    background: #fff;
    border-bottom: 2px solid #ddd;

    .fixed-close {
      position: absolute;
      right: 50px;
      top: 1px;
      font-size: 50px;
      color: #999;
    }

    .section-title {
      background: #fff;
    }
  }

  .form-buttons {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 99999;
    height: 130px;
    width: 100%;
    background: #fff;
    border-top: 2px solid #ddd;
    margin: 0;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;
  }

  .upload-requirements {
    padding: 12px;
    background: linear-gradient(135deg, #f0f4ff, #f8f9ff);
    border-radius: var(--radius-sm);
    border-left: 3px solid #667eea;
    margin-bottom: 16px;

    .req-title {
      font-size: 26px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
    }
  }

  .form-commit {
    font-size: 24px;
    margin-bottom: 20px;

    /deep/ .van-cell {
      font-size: 24px;

    }

    /deep/ .van-field__control {
      font-size: 24px;

    }
  }


  .inner-title {
    display: flex;
    font-weight: bold;
    justify-content: center;
    font-size: 36px;
    padding-top: 60px;
    box-sizing: border-box;
  }

  .inner-txt {
    display: flex;
    justify-content: center;
    color: #7f8c8d;
    padding-top: 30px;
    box-sizing: border-box;
  }

  .inner-btn {
    display: flex;
    justify-content: space-between;
    padding: 50px 40px 0;

    .block-btn {
      width: 46%;

      /deep/ .van-button__text {
        font-size: 28px;
      }
    }

    .font {
      background: #f5f6fa;

      /deep/ .van-button__text {
        color: #7f8c8d;
        font-size: 28px;
      }
    }
  }

  .switch-line {
    padding: 0 20px 0 10px;
    display: flex;
    flex-direction: row;
    margin-bottom: 20px;

    .line-box {
      width: 70%;
    }

    .line-number {
      width: 30%;
      display: flex;
      align-items: center;
      justify-content: center;

      span {
        color: var(--primary-color);
        font-size: 30px;
        font-weight: bold;
        padding-right: 10px;
      }
    }
  }

  .progress-container {
    margin-top: 20px;
    display: none;

    .progress-info {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      font-size: 14px;
      color: #2c3e50;
    }

    .progress-bar {
      height: 10px;
      background: #ecf0f1;
      border-radius: 5px;
      overflow: hidden;

      .progress-fill {
        height: 100%;
        background: #2ecc71;
        width: 0;
        transition: width 0.3s ease;
      }
    }
  }

  .progress-container.active {
    display: block;
  }

  .material-list-auto {

    .material-item-auto {
      display: flex;
      align-items: center;
      padding: 12px 18px 12px 18px;
      border-radius: var(--radius-md);
      margin-bottom: 18px;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
      background: #fff;

      .material-icon-auto {
        width: 60px;
        height: 60px;
        background-color: #e0e0e0;
        border-radius: var(--radius-sm);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 42px;
        margin-left: 8px;
        margin-right: 12px;
        flex-shrink: 0;
      }

      .material-switch {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 4px;
        margin-left: 12px;

        .check-btn {
          display: inline-block;
          outline: none;
          border: none;
          background: transparent;

          .check-box-group {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 40px;
            width: 40px;
            border-radius: var(--radius-sm);
            border: 1px solid #aaa;
            color: transparent;

            /deep/ .van-icon {
              display: inline-block;
              color: transparent;
            }
          }

          .checked {
            background: #e62d2d;
            border: 1px solid #e62d2d;
            color: #fff;

            /deep/ .van-icon {
              color: #fff;
            }
          }
        }

        .check-btn:disabled {
          background: #ddd;
          border-radius: var(--radius-sm);

          .check-box-group {
            border: 1px solid #ddd;
          }

          .checked {
            background: #ddd;
          }
        }
      }

      .material-info-auto {
        flex: 1;
        padding: 0 0 0 10px;


        .material-name-auto {
          font-size: 28px;
          font-weight: 500;
          margin-bottom: 4px;
          word-break: break-word;

          span {
            padding: 4px;
            font-size: 22px;
          }

          .gGeneral {
            background-color: #e3f2fd;
            color: #1976d2;
          }

          .pPersonal {
            background-color: #fff2fd;
            color: #ff9800;
          }

        }

        .material-meta {
          font-size: 24px;
          color: #7f8c8d;

          span {

            font-size: 24px;
          }

          .red {
            font-weight: bold;
            color: #e62d2d;
          }
        }

      }

    }
  }

  .tabs-group {
    padding: 120px 30px 130px;
    overflow-y: auto;
    overflow-x: hidden;
    background: #fff;

    .aerial-up {
      display: flex;
      flex-direction: column;

      .filter-section {
        border-radius: var(--radius-md);
        padding: 12px 0;
        margin-bottom: 16px;

        .filter-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 12px;
          align-items: flex-end;

          .filter-group {
            display: flex;
            flex-direction: column;

            .filter-label {
              color: var(--text-secondary);
              margin-bottom: 6px;
              font-weight: 500;
            }

            .filter-select {
              padding: 8px 12px;
              border: 1px solid var(--border-color);
              border-radius: var(--radius-sm);
              color: var(--text-color);
              background-color: white;
              cursor: pointer;
              transition: all 0.2s;
            }
          }
        }
      }

      .tabs-style {
        display: flex;
        flex-direction: column;
        height: 70px;

        .infant {
          font-size: 26px;
          margin-right: 5px;
          display: flex;
          align-items: center;
          justify-content: center;

          .vanish {
            margin-right: 4px;
          }
        }

        /deep/ .van-tabs {
          height: 100%;
        }

        /deep/ .van-tabs__wrap {
          height: 100%;
        }

        /deep/ .van-tabs--line {
          height: 100%;
        }

        /deep/ .van-tabs__nav {
          background: transparent;

        }

        /deep/ .van-tabs__wrap {
          overflow-x: auto;
          -webkit-overflow-scrolling: touch;
        }

        /deep/ .van-tabs__nav {
          flex-wrap: nowrap;
          min-width: 100%;
        }

        /deep/ .van-tabs__nav--complete {
          padding-left: 0;
        }

        /deep/ .van-tab {
          margin-right: 20px;
          border-radius: 50px;
          background: #fff;
          padding: 0 30px;
          border: 2px solid #eee;
        }

        /deep/ .van-tab__text {
          font-size: 24px;
          min-width: 150px;
        }

        /deep/ .van-tab--active {
          border-radius: 50px;
          background: #e62d2d;
          color: #fff;

          .num-style {
            display: flex;
            justify-content: center;
            align-items: center;
            color: #fff;
            background: #c11f1f;
            height: 50px;
            min-width: 50px;
          }
        }

        /deep/ .van-tabs__line {
          height: 0;
        }

        .icon-style {
          font-size: 28px;
          margin-right: 5px;
        }

        .num-style {
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 50%;
          padding: 3px 10px;
          font-size: 24px;
          color: #555;
          margin-left: 4px;
          background: rgba(0, 0, 0, 0.1);
          height: 50px;
          min-width: 50px;
        }
      }
    }

    .list-add-data {
      display: flex;
      flex: 1;
      width: 100%;
      margin-bottom: 20px;
      overflow-y: auto;
      padding: 20px;
      border-radius: var(--radius-md);
      background: linear-gradient(135deg, rgba(231, 76, 60, 0.08) 0%, rgba(192, 57, 43, 0.08) 100%);

      .van-list {
        width: 100%;
      }
    }
  }
}

.group-video {
  border-radius: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  position: relative;

  .group-video-load {
    position: relative;
    border-radius: 10px;
    height: 200px;
    width: 200px;
    border: 2px dashed #e9e9e9;
    overflow: hidden;

    .upload-area {
      border-radius: 12px;
      padding: 40px 20px;
      text-align: center;
      background: transparent;
      margin-bottom: 20px;
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;

      .file-input {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        opacity: 0;
        cursor: pointer;
        background: transparent;
      }

      .icon-calm {
        position: absolute;
        width: 60px;
        height: 60px;
        font-size: 46px;
        color: #ddd;
      }
    }

    /deep/ .van-uploader {
      width: 100%;
      height: 100%;
      overflow: hidden;

    }

    /deep/ .van-uploader__wrapper {
      width: 100% !important;
      height: 100% !important;

    }

    /deep/ .van-uploader__preview {
      width: 100% !important;
      height: 100% !important;
      margin: 0;
    }

    /deep/ .van-uploader__preview-image {
      width: 100% !important;
      height: 100% !important;
    }

    /deep/ .van-uploader__upload {
      width: 100% !important;
      height: 100% !important;
      margin: 0;
    }

    /deep/ .van-uploader__file {
      width: 100% !important;
      height: 100% !important;
      margin: 0;
    }

    .post-video {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 3;
      overflow: hidden;

      video {
        width: 100%;
        height: 100%;
        overflow: hidden;
      }
    }

    .group-load-item {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 1;
      transform: translate(-50%, -50%);
      border-radius: 10px;
      padding: 70px 0;
      text-align: center;
      width: 100%;
      height: 100%;
      font-size: 28px;

      .video-icon-img {
        width: 80px;
        height: 50px;
        margin: 0 auto;
        font-size: 60px;
        color: #ababab;

        img {
          width: 80px;
          height: 50px;
        }
      }

      .video-icon-txt {
        color: #ababab;
        padding-top: 20px;
      }
    }

    .aod {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 10000;
      color: #fff;
      font-size: 30px;
      height: 44px;
      line-height: 44px;
      width: 44px;
      text-align: center;
      background: #222;
      border-radius: 0 12px 0 0.32rem;
    }
  }
}

.list-box-tip {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.list-data {
  .filter-section {
    border-radius: var(--radius-md);
    padding: 12px 0;
    margin-bottom: 16px;

    .filter-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 12px;
      align-items: flex-end;

      .filter-group {
        display: flex;
        flex-direction: column;

        .filter-label {
          color: var(--text-secondary);
          margin-bottom: 6px;
          font-weight: 500;
        }

        .filter-select {
          padding: 8px 12px;
          border: 1px solid var(--border-color);
          border-radius: var(--radius-sm);
          color: var(--text-color);
          background-color: white;
          cursor: pointer;
          transition: all 0.2s;
        }
      }
    }
  }
}

/deep/ .van-cell {
  padding: 14px 14px;
  font-size: 24px;
  border: 2px solid #eee;
  border-radius: 12px;
}

/deep/ .van-field__control:read-only {
  font-size: 24px;
}

/deep/ .el-slider__runway {
  height: 0.28rem;
  border-radius: 10px;
}

/deep/ .el-slider__button {
  height: 0.6rem;
  width: 0.6rem;
  background: var(--primary-color);
  border: 0.08rem solid #fff;
}

/deep/ .el-slider__bar {
  height: 0.28rem;
  border-radius: 10px;
  background: var(--primary-color);
}

/deep/ .van-uploader__preview-delete {
  height: 48px !important;
  width: 48px !important;
  z-index: 5;
}

/deep/ .van-uploader__preview-delete-icon {
  top: -8px !important;
  right: -8px !important;
  font-size: 60px !important;
}

/deep/ .van-uploader__file-name {
  color: transparent;
}
</style>